import Vue from 'vue'
import i18n from '@/locales'

// 异步加载策略信息的组件
const AsyncPolicies = Vue.extend({
  props: {
    policies: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      policyData: [],
      loading: true,
    }
  },
  async mounted () {
    try {
      const ids = (this.policies || []).map(item => item.policy_id || item).filter(Boolean)
      if (!ids.length) {
        this.loading = false
        return
      }
      const manager = new this.$Manager('policies', 'v1')
      const res = await manager.batchGet({ id: ids })
      this.policyData = res.data?.data || []
    } catch (error) {
      console.error('Failed to fetch policies:', error)
    } finally {
      this.loading = false
    }
  },
  render (h) {
    if (this.loading) {
      return h('div', i18n.t('common.loading') + '...')
    }
    if (!this.policyData.length && (!this.policies || !this.policies.length)) {
      return h('div', '-')
    }
    const names = this.policyData.length
      ? this.policyData.map(p => p.name || p.id).join(', ')
      : this.policies.map(p => p.policy_id || p).join(', ')
    return h('div', `${i18n.t('dictionary.policy')}: ${names}`)
  },
})

// 异步加载 rolepolicies 信息的组件（通过 resource_ids 获取并展示策略）
const AsyncRolePolicies = Vue.extend({
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      rolePolicies: [],
      loading: true,
    }
  },
  async mounted () {
    try {
      const ids = (this.ids || []).filter(Boolean)
      if (!ids.length) {
        this.loading = false
        return
      }
      const manager = new this.$Manager('rolepolicies', 'v1')
      const res = await manager.batchGet({ id: ids })
      this.rolePolicies = res.data?.data || []
    } catch (error) {
      console.error('Failed to fetch rolepolicies:', error)
    } finally {
      this.loading = false
    }
  },
  render (h) {
    if (this.loading) {
      return h('div', i18n.t('common.loading') + '...')
    }
    if (!this.rolePolicies.length && (!this.ids || !this.ids.length)) {
      return h('div', '-')
    }
    const names = this.rolePolicies.length
      ? this.rolePolicies.map(rp => rp.policy || rp.policy_id || rp.id).join(', ')
      : this.ids.join(', ')
    return h('div', `${i18n.t('dictionary.policy')}: ${names}`)
  },
})

// 通用工单展示配置列
export const getShopCartWorkflowResourceConfigColumn = () => {
  return {
    field: 'config',
    title: i18n.t('common_428'),
    slots: {
      default: ({ row }, h) => {
        const { resource, action, perform_action_name, parameter, batch_resource_ids } = row
        const ret = []
        if (action === 'perform' && perform_action_name === 'set-policies') {
          const { policies } = parameter || {}
          if (policies && policies.length) {
            ret.push(h(AsyncPolicies, {
              props: {
                policies,
              },
            }))
          }
        } else if (resource === 'rolepolicies' && action === 'batch_delete') {
          if (batch_resource_ids && batch_resource_ids.length) {
            ret.push(h(AsyncRolePolicies, {
              props: {
                ids: batch_resource_ids,
              },
            }))
          }
        }
        return ret.length ? ret : '-'
      },
    },
  }
}
